module.exports = __webpack_public_path__ + "assets/img/18_1850_big.d5db9720.jpg";